export const OPTIONS = [
  //'prefix',
  'templateDelimiters',
  'rootInterface',
  'preloadData',
  'handler'
]

export const COMPS = 'components'

export const EXTENSIONS = [
  'binders',
  'formatters',
  COMPS,
  'adapters'
]